import { Component } from '@angular/core';
import { InputComponent } from '../input/input.component';

@Component({
  selector: 'app-input-currency',
  templateUrl: './input-currency.component.html',
  styleUrls: ['./input-currency.component.less']
})
export class InputCurrencyComponent extends InputComponent {
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/input-currency/input-currency.component.ts